module.exports = __webpack_public_path__ + "img/cards_image_visa.851694b.svg";